export default {"src":"/_next/static/media/0x130966628846bfd36ff31a822705796e8cb8c18d.652cee79.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};